import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDerspiegelComponent } from './simple-icons-derspiegel.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDerspiegelComponent ],
    exports:      [ SimpleIconsDerspiegelComponent ],
    bootstrap:    []
})
export class SimpleIconsDerspiegelModule {}
